/**
 * Creates reducers and actions for the "slices" of state of this module.
 */
import { createEntityAdapter, createSlice, } from "@reduxjs/toolkit";
/**
 * Please read up https://redux-toolkit.js.org/usage/usage-with-typescript#createentityadapter to understand what this is.
 */
export const measurementsAdapter = createEntityAdapter();
/**
 * The reducers for the module.
 */
const reducers = {
    createMeasurement: measurementsAdapter.addOne,
    updateMeasurement: measurementsAdapter.updateOne,
    updateMeasurements: measurementsAdapter.upsertMany,
    setFiles: (state, action) => {
        state.files = action.payload;
    },
    measurementsReceived: (state, action) => {
        state.loading = false;
        measurementsAdapter.upsertMany(state, action.payload);
    },
    measurementsLoading: (state) => {
        state.loading = true;
        state.didInvalidate = false;
    },
    measurementsError: (state, action) => {
        state.loading = false;
        state.error = action.payload;
    },
    invalidate: (state) => {
        state.didInvalidate = true;
    },
    setGloballyUniqueMeasurementColors: (state, action) => {
        state.globallyUniqueMeasurementColors = action.payload;
    },
    setDataScale: (state, action) => {
        state.dataScale = action.payload;
    },
};
const measurementsSlice = createSlice({
    name: "measurements",
    initialState: measurementsAdapter.getInitialState({
        error: undefined,
        loading: false,
        didInvalidate: true,
        measurementScale: 1,
        files: [],
        colors: [
            "#1f77b4",
            "#ff7f0e",
            "#2ca02c",
            "#d62728",
            "#9467bd",
            "#8c564b",
            "#e377c2",
            "#7f7f7f",
            "#bcbd22",
            "#17becf",
        ],
        globallyUniqueMeasurementColors: true,
        dataScale: 1,
    }),
    reducers,
});
export const { setFiles, createMeasurement, updateMeasurement, updateMeasurements, invalidate, measurementsReceived, measurementsLoading, measurementsError, setGloballyUniqueMeasurementColors, setDataScale, } = measurementsSlice.actions;
/**
 * Selects (from the state) the index of the color that should be applied to the next measurements
 * @param state The state from which the value should be selected.
 * @returns
 */
export const selectLastColorIndex = (state) => {
    const index = state.ids.reduce((acc, curr) => {
        const measurement = state.entities[curr];
        return Math.max((measurement === null || measurement === void 0 ? void 0 : measurement.color) ? state.colors.indexOf(measurement === null || measurement === void 0 ? void 0 : measurement.color) : -1, acc);
    }, -1);
    return index;
};
export const selectLastColorIndexPerDataViewer = (state, dataViewerId) => {
    const index = state.ids.reduce((acc, curr) => {
        var _a, _b;
        const measurement = state.entities[curr];
        return Math.max(((_a = measurement === null || measurement === void 0 ? void 0 : measurement.colorPerDataViewer) === null || _a === void 0 ? void 0 : _a.byId[dataViewerId])
            ? state.colors.indexOf((_b = measurement === null || measurement === void 0 ? void 0 : measurement.colorPerDataViewer) === null || _b === void 0 ? void 0 : _b.byId[dataViewerId])
            : -1, acc);
    }, -1);
    return index;
};
export default measurementsSlice.reducer;
//# sourceMappingURL=measurements.slice.js.map